import { useCallback, useEffect, useState } from 'react';
import { useSWRConfig } from 'swr';
import axios from 'axios';

import { enqueueSnackbar } from '@/providers/SnackbarProvider';
import { useLogout } from '@/hooks/useLogout';
import { usePrivate } from './PrivateContext';

const AUTH_PROXY = '/api/proxy/auth';

export function useWelcomeFlow() {
  const { mutate } = useSWRConfig();
  const { userId, userProfile } = usePrivate();
  const { logout } = useLogout();

  const [welcomeDialogOpen, setWelcomeDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userProfile && !userProfile.isEulaAccepted) {
      setWelcomeDialogOpen(true);
    }
  }, [userProfile]);

  const handleClickBack = useCallback(() => {
    logout();
  }, [logout]);

  const handleSubmit = useCallback(
    async (preferredName: string) => {
      if (!userId || loading) return;

      setLoading(true);
      try {
        await axios.patch(`${AUTH_PROXY}/api/UserProfile/CompleteWelcome`, {
          userId,
          preferredName,
        });

        setWelcomeDialogOpen(false);
        mutate(`/api/UserProfile/${userId}`);
      } catch (error) {
        enqueueSnackbar(
          'Something went wrong saving your details. Please try again or contact support.',
          { variant: 'error' },
        );
        console.error('[BREEDLOGIC] useWelcomeFlow:handleSubmit', error);
      } finally {
        setLoading(false);
      }
    },
    [userId, loading, mutate],
  );

  return {
    welcomeDialogOpen,
    isSubmittingWelcome: loading,
    onClickBackWelcome: handleClickBack,
    onSubmitWelcome: handleSubmit,
  };
}
